
















import {Component, InjectComponent, ComparisonProductProperty, Prop, Vue, VueComponent} from "@zoovu/runner-browser-api";

@Component({})
export default class PropertyHeaderView extends Vue {

    @Prop()
    property: ComparisonProductProperty;

    @InjectComponent("InfoText")
    infoText: VueComponent;

    infoTextShown: boolean = false;

    showInfoText() {
        this.infoTextShown = true;
    }

    hideInfoText() {
        this.infoTextShown = false;
    }
}
